<template>
    <b-card class="cardInsp" @click="changePath('pathName')">
        <img
            width="25px"
            v-if="phaseDone(pathName)"
            src="@/assets/imgs/ic_checked.png"
            alt=""
        />
        <img width="25px" v-else src="@/assets/imgs/ic_unchecked.png" alt="" />
        <span>
            {{ phaseName }}
        </span>
    </b-card>
</template>

<script>
import {BCard} from "bootstrap-vue";
export default {
    props: {
        phaseName: String,
        pathName: String,
    },
    components: {
        BCard
    },
    methods: {
        camelToKebab(text) {
            return text.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
        },
        changePath: function () {
            this.$router.push(this.camelToKebab(this.pathName));
        },
        phaseDone: function (pathName) {
            return this.$store.state.inspectionPhases[pathName];
        },
    },
};
</script>

<style scoped>
.cardInsp {
    height: 60px;
}
</style>
